import { type QueryClient, queryOptions } from "@tanstack/react-query";
import { ApiError, api, unwrap } from "@/client/lib/api";
import { ensureTenantData } from "@/client/lib/session";
import type { PersonDetail, PersonRow } from "@/features/people/schemas";

/** Searched and sorted in memory, so neither is ever a new request. */
export const peopleQuery = queryOptions({
  queryKey: ["people"],
  queryFn: (): Promise<PersonRow[]> =>
    unwrap(api.people.$get()).then(({ items }) => items),
});

export const personQuery = (personId: string) =>
  queryOptions({
    queryKey: ["people", personId],
    queryFn: (): Promise<PersonDetail> =>
      unwrap(api.people[":personId"].$get({ param: { personId } })),
  });

/**
 * A person in another company, one who does not exist and an id that is not a person's all answer
 * false, so the screen cannot tell them apart.
 */
export async function ensurePerson(
  queryClient: QueryClient,
  personId: string,
): Promise<boolean> {
  try {
    await ensureTenantData(queryClient, personQuery(personId));
    return true;
  } catch (failure) {
    if (
      failure instanceof ApiError &&
      (failure.code === "NOT_FOUND" || failure.code === "VALIDATION_FAILED")
    ) {
      return false;
    }
    throw failure;
  }
}
